import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCompanyMemberAccesses } from 'contracts/CompanyMemberAccesses';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_COMPANY_MEMBER_ACCESSES_',
  }
);

export interface ListCompanyMemberAccessesState {
  data: ListedCompanyMemberAccesses[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCompanyMemberAccessesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCompanyMemberAccesses[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCompanyMemberAccessesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCompanyMemberAccessesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: ListCompanyMemberAccessesState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: ListCompanyMemberAccessesState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCompanyMemberAccessesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listCompanyMemberAccesses = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCompanyMemberAccessesTypes = Types;
export const ListCompanyMemberAccessesActions = Creators;
